<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="12"></left-panel>
    </div>
    <div class="post-login-2-col-2" *ngIf="this.Insurandash && this.Insurandash.length > 0 ">
        <div>
            <div class="font-600 font-size-20px line-h-40 color-base-1700">
                {{"MyInsurance" | translate }}
            </div>

             <div class="card-slider insurance mt-10 p-10">
                    <owl-carousel-o [options]="carouselOptions" (translated)="selectCard($event)">
                        <ng-template carouselSlide *ngFor="let item of this.Insurandash; let i = index">
                             <div class="card mt-15">
                            <div class="img-box">
                                <img src="~/../assets/images/card-insurance-bg.jpg" alt=""
                                    *ngIf="item.productName == 'MOTOR'">
                                <img src="~/../assets/images/card-insurance-medical-bg.jpg" alt=""
                                    *ngIf="item.productName == 'MEDICAL'">
                                <img src="~/../assets/images/card-insurance-travel-bg.jpg" alt=""
                                    *ngIf="item.productName == 'TRAVEL'">

                                <div class="text-box p-15">
                                    <grid-row class="align-item-center justify-content-between">
                                        <grid-col col="auto">
                                            <ng-icon iconClass="icon-t v-align-middle mr-5" width="15"
                                                height="15"></ng-icon>
                                            <span
                                                class="font-400 font-size-12px letter-spacing-1 color-base-100 text-uppercase"
                                                *ngIf="item.productName == 'MOTOR'">
                                                {{"CarInsurance" | translate}}
                                            </span>
                                            <span
                                                class="font-400 font-size-12px letter-spacing-1 color-base-100 text-uppercase"
                                                *ngIf="item.productName == 'MEDICAL'">
                                                {{"MEDICALINSURANCE" | translate}}
                                            </span>
                                            <span
                                                class="font-400 font-size-12px letter-spacing-1 color-base-3500 text-uppercase"
                                                *ngIf="item.productName == 'TRAVEL'">
                                                {{"TRAVELINSURANCE" | translate}}
                                            </span>
                                        </grid-col>
                                        <grid-col col="auto" class="text-align-right"  *ngIf="item.productName">
                                            <span
                                                class="bg-base-100 br-40 pl-8 pr-8 pt-4 pb-4 pt-2 font-400 font-size-12px color-base-700">
                                                <!-- SAYED HASAN -->{{item.productName}}
                                            </span>
                                        </grid-col>
                                    </grid-row>


                                    <grid-row class="mt-5">
                                        <grid-col col="auto">
                                            <div
                                                class="font-400 font-size-10px text-uppercase letter-spacing-03 color-base-100">
                                                {{"PolicyNumber" | translate}}
                                            </div>
                                            <div class="font-600 font-size-12px letter-spacing-1 color-base-100">
                                                <!-- 123/POLICY/2023 -->{{item.policyNo}}
                                            </div>
                                        </grid-col>
                                    </grid-row>

                                    <grid-row class="align-item-center col-space justify-content-between mt-5">
                                        <grid-col col="auto" *ngIf="item.productName == 'MOTOR'">
                                            <div
                                                class="font-400 font-size-10px text-uppercase letter-spacing-03 color-base-100">
                                                {{"CarMakeModel" | translate}}
                                            </div>
                                            <div class="font-500 font-size-9px letter-spacing-1 color-base-100">
                                                <!-- AUDI A3 (2020) -->{{item.motorInsuredDetail.carMake}}
                                                {{item.motorInsuredDetail.model}}{{item.motorInsuredDetail.manufactureYear}}
                                            </div>
                                        </grid-col>
                                        <grid-col col="auto"
                                            *ngIf="item.productName == 'MOTOR' && item.motorInsuredDetail.regestrationNo">
                                            <div
                                                class="font-400 font-size-10px text-uppercase letter-spacing-03 color-base-100">
                                                {{"CarRegistration" | translate}}
                                            </div>
                                            <div
                                                class="font-600 font-size-12px letter-spacing-1 color-base-100 text-align-left">
                                                <!-- 52236 -->{{item.motorInsuredDetail.regestrationNo}}
                                            </div>
                                        </grid-col>


                                        <grid-col col="auto"
                                            *ngIf="item.productName == 'MEDICAL' || item.productName == 'TRAVEL' ">
                                            <div
                                                class="font-400 font-size-10px mt-12 text-uppercase letter-spacing-03 color-base-100">
                                                {{"CardNumber" | translate}}
                                            </div>
                                            <div class="font-600 font-size-12px letter-spacing-1 color-base-100"
                                                *ngIf="item.productName == 'MEDICAL'">
                                                {{item.medicalInsuredDetail?.cardNumber}}
                                            </div>
                                            <div class="font-600 font-size-12px letter-spacing-1 color-base-100"
                                                *ngIf="item.productName == 'TRAVEL'">
                                                {{item.travelInsuredDetail?.cardNumber}}
                                            </div>
                                        </grid-col>
                                        <!-- <grid-col col="auto" *ngIf="item.productName == 'MEDICAL'">
                                            <div
                                                class="font-400 font-size-10px mt-12 text-uppercase letter-spacing-03 color-base-100">
                                                {{"Category" | translate}}
                                            </div>
                                            <div
                                                class="font-600 font-size-12px letter-spacing-1 color-base-100 text-align-left">
                                                  {{CategoryValue}}

                                            </div>
                                        </grid-col> -->


                                    </grid-row>

                                    <grid-row class="justify-content-between align-item-center mt-5">
                                        <grid-col col="9" *ngIf="item.productName == 'MOTOR'">
                                            <div
                                                class="font-400 font-size-10px line-h-14 color-base-100 letter-spacing-1 text-uppercase">
                                                {{"SUMINSUREDAMOUNT" | translate }}
                                            </div>
                                            <div class="font-size-12px color-base-100">
                                                <span class="line-h-14 font-600">
                                                    {{"BHD" | translate }}
                                                </span>
                                                <span class="line-h-14 font-600">
                                                    <!-- 7,900.000 -->{{item.sumInsuredAmount}}
                                                </span>
                                            </div>
                                        </grid-col>
                                        <grid-col col="auto" *ngIf="item.productName == 'MOTOR'">
                                            <ng-icon iconClass="icon-car br-100" width="40" height="40"></ng-icon>
                                        </grid-col>


                                        <grid-col col="9" *ngIf="item.productName == 'MEDICAL'">
                                            <div
                                                class="font-400 font-size-10px line-h-14 color-base-100 letter-spacing-1 text-uppercase">
                                                {{"DateofBirth" | translate }}
                                            </div>
                                            <div
                                                class="font-600 font-size-12px letter-spacing-1 color-base-100 text-align-left">
                                                {{item.medicalInsuredDetail[0]?.dependentDOB}}
                                            </div>
                                        </grid-col>
                                        <grid-col col="auto" *ngIf="item.productName == 'MEDICAL'">
                                            <ng-icon iconClass="icon-medical br-100" width="40" height="40"></ng-icon>
                                        </grid-col>
                                        <grid-col col="auto" *ngIf="item.productName == 'TRAVEL'">
                                            <ng-icon iconClass="icon-aeroplane br-100" width="40" height="40"></ng-icon>
                                        </grid-col>
                                    </grid-row>

                                    <div>
                                        <span class="font-400 font-size-10px line-h-14 mr-5 color-base-100">
                                            {{"Effectivedate"| translate}}
                                        </span>
                                        <span class="font-600 font-size-10px line-h-14 color-base-100">
                                            {{item.policyIssueDate | date:"dd/MM/yyyy"}}
                                        </span>
                                    </div>

                                    <grid-row class="align-item-center justify-content-between col-space-min">
                                        <!-- <grid-col col="auto">
                <span class="font-400 font-size-10px line-h-14 mr-5 color-base-100">
                    {{"Effectivedate"| translate}}
                </span>
                <span class="font-600 font-size-10px line-h-14 color-base-100">
                    {{item.policyStartDate | date:"dd/MM/YYYY"}}
                </span>
            </grid-col> -->
                                        <grid-col col="7">
                                            <span class="font-400 font-size-10px line-h-14 mr-5 color-base-100">
                                                {{"Expirationdate"| translate}}
                                            </span>
                                            <span class="font-600 font-size-10px line-h-14 color-base-100">
                                                {{item.policyEndDate | date:"dd/MM/yyyy"}}
                                            </span>
                                        </grid-col>
                                        <grid-col col="auto justify-content-between align-item-right">
                                            <span
                                                class="font-400 font-size-10px color-base-100 bg-success pt-3 pb-3 pl-10 pr-10 br-100px"
                                                *ngIf="item.policyStatus == 'Active'">
                                                {{item.policyStatus}}
                                            </span>
                                            <span
                                                class="font-400 font-size-10px color-base-100 bg-warning pt-3 pb-3 pl-10 pr-10 br-100px"
                                                *ngIf="item.policyStatus == 'Due For Renewal'">
                                                {{item.policyStatus}}
                                            </span>
                                            <span
                                                class="font-400 font-size-10px color-base-100 bg-idle  pt-3 pb-3 pl-10 pr-10 br-100px"
                                                *ngIf="item.policyStatus == 'In-Active'">
                                                {{item.policyStatus}}
                                            </span>
                                            <span
                                                class="font-400 font-size-10px color-base-100 bg-error pt-3 pb-3 pl-10 pr-10 br-100px"
                                                *ngIf="item.policyStatus == 'Expired'">
                                                {{item.policyStatus}}
                                            </span>
                                        </grid-col>
                                    </grid-row>
                                </div>
                            </div>
                        </div>
                        </ng-template>
                    </owl-carousel-o>
                </div>


            <div class="font-400 font-size-14px line-h-20 color-base-1200 mt-40 text-uppercase">
                {{"InsuredDetails" | translate }}
            </div>
            <div class="bg-base-100 box-shadow border border-color-900 text-align-center br-16 mt-10 p-16">
                <grid-row class="justify-content-between mt-8">
                    <grid-col col="auto">
                        <div class="font-400 font-size-12px line-h-20 color-base-1800">
                            {{"CustomerName" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            <!-- Mariam rashid -->{{this.selectedInsuDetail?.customerName}}
                        </div>
                    </grid-col>
                </grid-row>


                <!--------------------------------------------------------MOTOR INSURANCE DETAILS--------------------------------------------------------------------------------------->
                <grid-row class="justify-content-between mt-24" *ngIf="this.selectedInsuDetail?.productName == 'MOTOR'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"CarModel" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            <!-- Honda - Accord -->{{this.selectedInsuDetail?.motorInsuredDetail?.carMake}} -
                            {{this.selectedInsuDetail?.motorInsuredDetail?.model}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24" *ngIf="this.selectedInsuDetail?.productName == 'MOTOR'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"ChassisNumber" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.motorInsuredDetail?.chassisNumber}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24 mb-8"
                    *ngIf="this.selectedInsuDetail?.productName == 'MOTOR'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"RegistrationNumber" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.motorInsuredDetail?.regestrationNo}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24 mb-8"
                    *ngIf="this.selectedInsuDetail?.productName == 'MOTOR'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"RegistrationMonth" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.motorInsuredDetail?.regestrationMonth}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24 mb-8"
                    *ngIf="this.selectedInsuDetail?.productName == 'MOTOR'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"ManufacturingYear" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.motorInsuredDetail?.manufactureYear}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24 mb-8"
                    *ngIf="this.selectedInsuDetail?.productName == 'MOTOR'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"NumberofPassengers" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.motorInsuredDetail?.noOfPassengers}}
                        </div>
                    </grid-col>
                </grid-row>
                <grid-row class="justify-content-between mt-24 mb-8"
                    *ngIf="this.selectedInsuDetail?.productName == 'MOTOR'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"DriversAge" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500"
                            *ngIf="this.selectedInsuDetail?.productName == 'MOTOR'">
                            {{this.selectedInsuDetail?.motorInsuredDetail?.driverAge}}
                        </div>
                    </grid-col>
                </grid-row>
                <!--------------------------------------------------------MEDICAL INSURANCE DETAILS--------------------------------------------------------------------------------------->

                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'MEDICAL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"PolicyNumber" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            <!-- Honda - Accord -->{{this.selectedInsuDetail?.medicalInsuredDetail?.PolicyNumber}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'MEDICAL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"cardNumber" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.medicalInsuredDetail?.cardNumber}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'MEDICAL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"dependentRelation" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.medicalInsuredDetail?.dependentRelation}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'MEDICAL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"dependentIdNumber" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.medicalInsuredDetail?.dependentIdNumber }}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'MEDICAL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"dependentFullName " | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.medicalInsuredDetail?.dependentFullName}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'MEDICAL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"dependentDOB" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.medicalInsuredDetail?.dependentDOB}}
                        </div>
                    </grid-col>
                </grid-row>
                <!--------------------------------------------------------TRAVEL INSURANCE DETAILS--------------------------------------------------------------------------------------->

                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'TRAVEL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"PolicyNumber" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.travelInsuredDetail?.PolicyNumber}}
                        </div>
                    </grid-col>
                </grid-row>


                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'TRAVEL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"cardNumber" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.travelInsuredDetail?.cardNumber}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'TRAVEL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"dependentRelation" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.travelInsuredDetail?.dependentRelation}}
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'TRAVEL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"dependentIdNumber" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.travelInsuredDetail?.dependentIdNumber }}
                        </div>
                    </grid-col>
                </grid-row>


                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'TRAVEL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"dependentFullName " | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.travelInsuredDetail?.dependentFullName}}
                        </div>
                    </grid-col>
                </grid-row>


                <grid-row class="justify-content-between mt-24"
                    *ngIf="this.selectedInsuDetail?.productName == 'TRAVEL'">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"dependentDOB" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{this.selectedInsuDetail?.travelInsuredDetail?.dependentDOB}}
                        </div>
                    </grid-col>
                </grid-row>

                <!--------------------------------------------------------LIFE INSURANCE DETAILS--------------------------------------------------------------------------------------->

                <!--------------------------------------------------------PROPERTY INSURANCE DETAILS--------------------------------------------------------------------------------------->

                <grid-row class="justify-content-between mt-24 mb-8">
                    <grid-col col="auto">
                        <div class=" font-400 font-size-12px line-h-20 color-base-1800">
                            {{"SumInsured" | translate}}
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-600 font-size-14px line-h-20 color-base-1500">
                            {{"BHD" | translate }} {{this.selectedInsuDetail?.sumInsuredAmount | amountFormatter}}
                        </div>
                    </grid-col>
                </grid-row>
            </div>
        </div>

    </div>
    <div class="post-login-2-col-3" *ngIf="this.Insurandash.length > 0 ">
        <ng-container>
            <div>
                <div class="font-600 font-size-20px line-h-40 color-base-1700 text-uppercase">
                    {{"MyInsurance" | translate }}
                </div>
                <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1 text-uppercase mt-20">
                    {{"CardActions" | translate }}
                </div>

                <grid-row class="col-space-min mt-16">
                    <grid-col col="auto" mobile="6">
                        <div class="card-box-big link" [routerLink]="['/InsuranceBenefitsDocuments']">
                            <ng-icon iconClass="icon-benefit-green" width="26" height="27"></ng-icon>
                            <div class="font-600 font-size-10px line-h-14 mt-12 text-uppercase">
                                {{ "BenefitsDocuments" | translate }}
                            </div>
                        </div>
                    </grid-col>

                    <grid-col col="auto" mobile="6">
                        <div class="card-box-big link" [routerLink]="['/InsuranceClaims']">
                            <ng-icon iconClass="icon-claim-green" width="26" height="27"></ng-icon>
                            <div class="font-600 font-size-10px line-h-14 mt-12 text-uppercase">
                                {{ "CLAIMs" | translate }}
                            </div>
                        </div>
                    </grid-col>
                    <grid-col col="auto" mobile="6">
                        <div class="card-box-big link" [routerLink]="['/InsuranceAssistance']">
                            <ng-icon iconClass="icon-phone-call" width="26" height="27"></ng-icon>
                            <div class="font-600 font-size-10px line-h-14 p-3 color-base-1500 mt-10 text-uppercase">
                                {{ "Assistance" | translate }}
                            </div>
                        </div>
                    </grid-col>
                    <grid-col col="auto" mobile="6">
                        <div class="card-box-big" [routerLink]="['/InsuranceNick']">
                            <ng-icon iconClass="icon-more-action-green" width="26" height="27"></ng-icon>
                            <div class="font-600 font-size-10px line-h-14 p-3 color-base-1500 mt-10 text-uppercase">
                                {{ "InsuranceNick" | translate }}
                            </div>
                        </div>
                    </grid-col>
                </grid-row>

                <grid-row class="justify-content-between mt-30">
                    <grid-col col="auto">
                        <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1 text-uppercase">
                            {{"Policydetails" | translate }}
                        </div>
                    </grid-col>
                    <!-- <grid-col col="auto">
                                <div class="font-500 font-size-12px line-h-18 color-primary text-align-center letter-spacing-1 link">
                                    {{"ViewMore" | translate}}
                                </div>
                            </grid-col> -->
                </grid-row>


                <div class="bg-base-100 box-shadow border border-color-900 br-16 mt-10 p-16">


                    <!-- Comment by Asra as by jira ticket requirement BCFC-2342 -->

                    <!-- <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"Product" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                {{this.selectedInsuDetail.customerName}}
                            </div>
                        </grid-col>
                    </grid-row> -->
                    <!-- Comment by Asra as by jira ticket requirement BCFC-2342 -->

                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"Package" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- Comprehensive Gold - DIGITAL -->{{this.selectedInsuDetail.packageName}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"Company" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- Solidarity Bahrain B.S.C -->{{this.selectedInsuDetail.insuranceCompanyName}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"PolicyStartDate" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- 21/07/2023 -->{{this.selectedInsuDetail.policyStartDate | date:'dd/MM/yyyy'}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"PolicyEndDate" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- 29/07/2024 -->{{this.selectedInsuDetail.policyEndDate | date:'dd/MM/yyyy'}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"PolicyStatus" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- Active -->{{this.selectedInsuDetail.policyStatus}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"PolicyDueDate" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- 24 Days Remaining -->{{this.selectedInsuDetail.policyDueDays}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"SumInsured" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- BHD 7,900.000 --> {{"BHD" | translate }} {{this.selectedInsuDetail.sumInsuredAmount |
                                amountFormatter}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"PremiumAmount" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- BHD 239.000 -->{{"BHD" | translate }} {{this.selectedInsuDetail.premiumAmount | amountFormatter}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"VATRate" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- 10% -->{{this.selectedInsuDetail.vatRate}} %
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"VATAmount" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- BHD 23.000 -->{{"BHD" | translate }} {{this.selectedInsuDetail.vatAmount| amountFormatter}}
                            </div>
                        </grid-col>
                    </grid-row>
                    <grid-row class="justify-content-between mt-10 mb-10">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1400">
                                {{"TotalPremiumAmount" | translate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-600">
                                <!-- BHD 252.000 -->{{"BHD" | translate }} {{this.selectedInsuDetail.totalPremiumAmount | amountFormatter}}
                            </div>
                        </grid-col>
                    </grid-row>
                </div>
            </div>
        </ng-container>


    </div>
    <div class="post-login-2-col-3" *ngIf="this.Insurandash.length == 0">
        <ng-container>
            <grid-row class="justify-content-center h-100vh-80">
                <grid-col col="12">
                    <div class="font-600 font-size-20px line-h-40 color-base-1700 text-uppercase">
                        {{"MyInsurance" | translate }}
                    </div>
                </grid-col>
                <grid-col col="4" ipad="12">
                    <div class="text-align-center">
                        <ng-icon iconClass="icon-no-insurance" width="120" height="120"></ng-icon>
                    </div>
                    <div class="font-400 font-size-20px line-h-25 color-base-700 text-align-center mt-30">
                        {{"Noinsuranceavailable" | translate }}
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-10">
                        {{"Youdonthaveanyinsurance" | translate }}
                    </div>
                  
                    <!-- saheel switch yousuf  -->
                     <div *ngIf="this.serviceType === 'Islamic'">
                        <div class="font-400 font-size-14px line-h-20 color-base-500 text-align-center mt-30">
                        {{"Wouldyouliketoswitchinsurance" | translate }}
                    </div>
                    <grid-row class="justify-content-center mt-30">
                        <grid-col col="12">
                            <button class="btn-dft" (click)="userSwitch()">
                                {{ "switchtoSahelservices" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                    </div>
                    <!--  -->

                </grid-col>
            </grid-row>
        </ng-container>
    </div>
</div>